import React from 'react'
import clsx from 'clsx'
import ReactMarkdown from 'react-markdown'
import {ImgFilters} from '../components/ImgFilters'
import {Typography} from '../components/Typography'
import {Icon, IconButton, Button} from '../components/Button'
import {Tag} from '../components/Tag'
import {Card} from '../components/Card'
import youtube from '../img/social/youtube.svg'
import instagram from '../img/social/instagram.svg'
import facebook from '../img/social/facebook.svg'
import podcast from '../img/social/podcast.svg'
import telegram from '../img/social/telegram.svg'
import latters from '../img/social/latters.svg'
import heroImageDesk from '../img/AulaFree-Desk-1280x530.png'
import heroImageMobile from '../img/AulaFree-Mobile-450x530.png'
import image01 from '../img/aperfeicoamento.png'
import {useGetCoursesOfProfessor} from '../utils/hooks/useGetCoursesOfProfessor'

function removePrefixProfessor(professorName) {
  return professorName.replace('PROFº. ', '').replace('PROFª. ', '')
}

const components = {
  ul: ({children}) => (
    <ul className="pt-10 pl-10 list-disc-blue space-y-4">{children}</ul>
  ),
  strong: ({children}) => (
    <Typography as="strong" weight="black">
      {children}
    </Typography>
  ),
  li: ({children}) => (
    <Typography as="li" color="gray-900">
      {children}
    </Typography>
  ),
  p: ({children}) => (
    <Typography className="my-4 leading-8" color="gray-900">
      {children}
    </Typography>
  ),
  h1: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
  h2: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
  h3: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
  h4: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
  h5: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
  h6: ({children}) => (
    <Typography as="h3" color="gray-900" weight="black" className="mt-8">
      {children}
    </Typography>
  ),
}

const MaxContainer = ({children, className}) => {
  return (
    <div className={clsx('mx-auto', className)} style={{maxWidth: '1003px'}}>
      {children}
    </div>
  )
}
export const Hero = ({className, imgDesktop, imgMobile}) => {
  const style = clsx(`relative w-full h-40 mb-4`, className)
  return (
    <div className={style}>
      <ImgFilters
        img={imgMobile}
        transparency
        className="lg:hidden"
        imgPosition="bg-center"
      />
      <ImgFilters
        img={imgDesktop}
        transparency
        className="hidden lg:block"
        imgPosition="bg-center"
      />
    </div>
  )
}

const Path = props => (
  <MaxContainer className="px-10 mt-16 lg:px-0">
    <div>
      <Typography as="div">
        <Typography as="span" uppercase color="blue-500">
          Quem somos
        </Typography>{' '}
        /{' '}
        <Typography as="span" uppercase color="blue-500">
          Professores
        </Typography>{' '}
        /{' '}
        <Typography as="span" uppercase color="gray-900">
          {removePrefixProfessor(props.name)}
        </Typography>
      </Typography>
    </div>
  </MaxContainer>
)

const ProfessorMedia = ({
  socialYoutube,
  socialInstagram,
  socialFacebook,
  socialPodcast,
  socialTelegram,
  socialLatters,
}) => (
  <ul className="flex flex-row justify-center space-x-3">
    {socialInstagram && (
      <li>
        <IconButton as="a" href={socialInstagram}>
          <Icon icon={instagram} />
        </IconButton>
      </li>
    )}
    {socialLatters && (
      <IconButton as="a" href={socialLatters}>
        <Icon icon={latters} />
      </IconButton>
    )}
  </ul>
)

const ProfessorCard = ({
  image,
  cover,
  title = '',
  titleCard = '',
  slug = '',
  tag = {
    variant: 'blue',
    text: '',
  },
}) => {
  return (
    <Card>
      <Card.Image src={image || cover} />
      <Card.Content>
        <Card.Title title={title}>{titleCard}</Card.Title>
      </Card.Content>
      <Card.Action>
        <Button as="a" fullWidth className="uppercase" href={`/${slug}`}>
          saiba mais aqui
        </Button>
      </Card.Action>
    </Card>
  )
}

const Courses = ({courses}) => {
  return (
    <div className="flex flex-col justify-center px-4 mb-16">
      <div className="grid grid-cols-1 lg:grid-cols-3 gap-4">
        {courses.map(course => (
          <ProfessorCard key={course.slug} {...course} />
        ))}
      </div>
    </div>
  )
}

const PageTemplate = props => {
  const allCourses = useGetCoursesOfProfessor(props.name)

  return (
    <div className="relative">
      <Hero imgDesktop={heroImageDesk} imgMobile={heroImageMobile} />
      <Path {...props} />
      <div className="bg-blue-500-to-900-x h-24 py-2.5 mt-14">
        <MaxContainer>
          <Typography
            variant="heading-4xl"
            className="w-full text-center lg:text-left"
            uppercase
            color="white"
            weight="black"
          >
            {removePrefixProfessor(props.nameShort)}
          </Typography>
          <div className="flex justify-center lg:justify-start">
            <ProfessorMedia {...props.socialLinks} />
          </div>
        </MaxContainer>
      </div>
      <MaxContainer>
        <div className="relative flex flex-col-reverse items-center justify-center mt-12 lg:justify-start lg:items-start">
          <div
            className="px-10 lg:px-0"
            style={{minHeight: 470, maxWidth: '500px'}}
          >
            <ReactMarkdown components={components}>
              {props.descriptionLong}
            </ReactMarkdown>
          </div>
          <div
            className="mb-10 lg:right-0 lg:absolute"
            style={{
              width: '410px',
              height: '621px',
              top: '-184px',
              background: `url(${props.photo}) center 0% no-repeat`,
              backgroundSize: 'cover',
            }}
          />
        </div>
      </MaxContainer>
      {allCourses.length >= 1 && (
        <MaxContainer>
          <div className="w-full my-12 border-t border-gray-100" />
          <Typography
            variant="heading-4xl"
            className="text-center lg:text-right"
            color="blue-500"
            uppercase
          >
            Cursos do Professor
          </Typography>
          <Courses courses={allCourses} />
        </MaxContainer>
      )}
    </div>
  )
}

const Template = ({pageContext}) => {
  return <PageTemplate {...pageContext?.frontmatter} />
}

export default Template
